import $ from 'jquery';
import 'jquery.dotdotdot';

export default class Product {
	constructor(options) {
		const defaults = {
			el: '.js-product',

			dom: {
				brand: '.js-product-brand',
				descr: '.js-product-descr',
				productImage: '.js-product-item-image'
			},
			classes: {
				hidden: 'product__image_hidden'
			}
		};

		this.options = $.extend(true, {}, defaults, options);
		this.$el = $(this.options.el);
		return this;
	}

	getDom() {
		this.$brand = this.$el.find(this.options.dom.brand);
		this.$descr = this.$el.find(this.options.dom.descr);
		this.$productImage = this.$el.find(this.options.dom.productImage);
		return this;
	}

	truncateText() {
		this.$brand.dotdotdot({
			ellipsis: '... ',
			wrap: 'letter',
			height: 80,
			watch: 'window'
		});
		this.$descr.dotdotdot({
			ellipsis: '... ',
			wrap: 'letter',
			height: 100,
			watch: 'window'
		});
	}

	toggleImage(e) {
		const $target = $(e.currentTarget).children();
		$target.each(item => {
			const $item = $target.eq(item);
			if ($item.hasClass(this.options.classes.hidden)) {
				$item.removeClass(this.options.classes.hidden);

			} else {

				$item.addClass(this.options.classes.hidden);
			}
		});
	}

	render() {
		if (this.$el.length) {
			this.getDom();
			this.truncateText();
			if (this.$productImage.eq(0).children().length > 1) {
				this.$productImage.on('mouseenter', e => this.toggleImage(e));
				this.$productImage.on('mouseleave', e => this.toggleImage(e));
			}
		}
		return this;
	}
}



/** WEBPACK FOOTER **
 ** ./app/blocks/product/product.js
 **/